<template>
	<div style="display: flex; justify-content: center;">
		<el-form label-width="120px" :model="pInfo">
			<el-form-item label="登记号">
				<div>
					<el-input v-model="pInfo.PapmiNo" style="width: 200px;" disabled/>
				</div>
			</el-form-item>
			<el-form-item label="姓名">
				<div>
					<el-input v-model="pInfo.PapmiName" style="width: 200px;" disabled />
				</div>
			</el-form-item>
			<el-form-item label="手机号">
				<div>
					<el-input v-model="pInfo.PapmiTelH" style="width: 200px;" disabled />
				</div>
			</el-form-item>
			<el-form-item label="性别">
				<div>
					<el-radio-group v-model="pInfo.PapmiSex" disabled>
						<el-radio v-if="pInfo.PapmiSex === '1'" label="1">男</el-radio>
						<el-radio v-if="pInfo.PapmiSex === '2'" label="2">女</el-radio>
					</el-radio-group>
				</div>
			</el-form-item>
			<el-form-item label="出生日期" >
				<el-date-picker v-model="pInfo.PapmiDob" type="date" placeholder="出生日期" format="yyyy-MM-DD"
					value-format="yyyy-MM-DD" style="width: 200px;" disabled>
					<template #default="cell">
						<div class="cell" :class="{ current: cell.isCurrent }">
							<span class="text">{{ cell.text }}</span>
						</div>
					</template>
				</el-date-picker>
			</el-form-item>
			<el-form-item label="年龄">
				<el-row>
					<el-input v-model="pInfo.PapmiAge" style="width: 60px; margin-right: 5px;" disabled/><span>岁</span>
				</el-row>
			</el-form-item>
			<el-form-item label="右眼-医学验光">
				<el-input v-model="pInfo.YXYGDSYY" type="number" style="width: 60px; margin-right: 10px;" disabled /><span> DS
				</span>
				<el-input v-model="pInfo.YXYGDCYY" type="number"
					style="width: 60px; margin-left: 10px; margin-right: 10px;" disabled /><span> DC x </span>
				<el-input v-model="pInfo.YXYGXYY" type="number" style="width: 60px; margin-left: 10px;"  disabled />
			</el-form-item>
			<el-form-item label="右眼-设计度数">
				<el-input v-model="pInfo.SJDSDSYY" type="number" style="width: 60px; margin-right: 10px;" disabled /><span> DS
				</span>
				<el-input v-model="pInfo.SJDSDCYY" type="number"
					style="width: 60px; margin-left: 10px; margin-right: 10px;" disabled /><span> DC x </span>
				<el-input v-model="pInfo.SJDSXYY" type="number" style="width: 60px; margin-left: 10px;"  disabled/>
			</el-form-item>
			<el-form-item label="左眼-医学验光">
				<el-input v-model="pInfo.YXYGDS" type="number" style="width: 60px; margin-right: 10px;" disabled /><span> DS
				</span>
				<el-input v-model="pInfo.YXYGDC" type="number"
					style="width: 60px; margin-left: 10px; margin-right: 10px;" disabled /><span> DC x </span>
				<el-input v-model="pInfo.YXYGX" type="number" style="width: 60px; margin-left: 10px;" disabled />
			</el-form-item>
			<el-form-item label="左眼-设计度数">
				<el-input v-model="pInfo.SJDSDS" type="number" style="width: 60px; margin-right: 10px;" disabled /><span> DS
				</span>
				<el-input v-model="pInfo.SJDSDC" type="number"
					style="width: 60px; margin-left: 10px; margin-right: 10px;" disabled /><span> DC x </span>
				<el-input v-model="pInfo.SJDSX" type="number" style="width: 60px; margin-left: 10px;" disabled />
			</el-form-item>
			<el-form-item label="度数变化">
				<span> 右眼: </span><el-input class="color-red" v-model="pInfo.DSBHYY" style="width: 80px; margin-left: 5px;" disabled/>
				<span> 左眼: </span><el-input class="color-red" v-model="pInfo.DSBH" style="width: 80px; margin-left: 5px; margin-right: 5px;" disabled/>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'InfoPopup',
		props: {
			pInfo: {
				type: Object,
				default: null
			},
		},
		watch: {
			props: {
				immediate: true,
				handler(val) {
					console.log(val)
				},
			},
		}
	}
</script>

<style scoped>
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none !important;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}
	.el-input.is-disabled /deep/ .el-input__inner{
		color: #000;
	}
	.color-red /deep/ .el-input__inner{
		color: #ff0000 !important;
	}
</style>